import { useState } from "react";
import { Mail } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterBanner() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Subscribed");
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Subscription failed");
    } finally { setBusy(false); }
  };

  return (
    <section data-testid="newsletter-banner" className="py-16 md:py-20">
      <div className="container-page">
        <div className="relative overflow-hidden rounded-3xl bg-brand text-white p-8 md:p-14">
          <div className="absolute -right-16 -top-16 w-72 h-72 rounded-full bg-white/10" />
          <div className="absolute -right-8 bottom-0 w-48 h-48 rounded-full bg-accent/30" />
          <div className="relative grid md:grid-cols-2 gap-8 items-center">
            <div>
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/10 border border-white/20 text-[11px] uppercase tracking-widest mb-4">
                <Mail size={12} className="text-accent" /> Weekly travel deals
              </div>
              <h2 className="font-montserrat font-extrabold text-3xl md:text-4xl leading-tight">
                Be the first to grab limited deals
              </h2>
              <p className="mt-3 text-white/85 max-w-md">
                Join 50,000+ travellers getting handpicked flight + hotel offers in their inbox every Friday.
              </p>
            </div>
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid="newsletter-form">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                data-testid="newsletter-email"
                className="flex-1 h-12 px-4 rounded-lg bg-white text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-accent"
              />
              <button
                type="submit"
                disabled={busy}
                data-testid="newsletter-submit"
                className="h-12 px-7 rounded-lg btn-accent font-semibold uppercase tracking-wider text-sm disabled:opacity-60"
              >
                {busy ? "..." : "Subscribe"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
